export default {
      id: "services-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg#services",
      toString: function () {
        return this.url;
      }
    }